<template>
  <v-menu :open-on-hover="!$vuetify.display.xs"
          class="rounded-lg"
          location="bottom left"
          transition="slide-y-transition"
  >
    <template v-slot:activator="{ props, value }">
      <AppBarMenuItem :hover="value"
                      v-bind="props"
      >
        <app-icon-ds icon="question-circle" weight="fal" size="sm" color="inherit" />
      </AppBarMenuItem>
    </template>

    <v-list density="compact">
      <v-list-item :href="$t('common.app-bar.HelpMenuItem.urlHelpCenter')" target="_blank">
        <v-list-item-title>
          {{ $t("common.app-bar.HelpMenuItem.helpCenter") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="webinarLinkShouldBeDisplayed"
                   :href="webinarUrl"
                   target="_blank"
      >
        <v-list-item-title>
          {{ $t("common.app-bar.HelpMenuItem.webinar") }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import AppBarMenuItem from './AppBarMenuItem.vue'

export default {
  name: 'HelpMenuItem',
  components: { AppBarMenuItem },
  data() {
    return {
      webinarUrl: import.meta.env.VUE_APP_WEBINAR_URL,
    }
  },
  computed: {
    webinarLinkShouldBeDisplayed() {
      return this.$i18n.locale === 'fr' && this.webinarUrl
    },
  },
}
</script>
